import { Controller } from "@hotwired/stimulus";

/** grade-select-form
 * 車検証情報画面のグレードの `<select>` 要素を制御する。
 */
export default class extends Controller {
  static outlets = ["tooltip-visibility"];

  // グレードのセレクトボックスが読み込まれた(更新された)
  connect() {
    // `option.value` の `-1` は「不明」
    const options = Array.from(this.element.options).filter(
      (option) => option.value && option.value != -1,
    );

    // 選択可能オプションが1件しか無い場合は選択済みにする
    if (options.length == 1) {
      options[0].selected = true;
    }

    this.update();
  }

  // グレードのセレクトボックスの値が変更された
  update() {
    // プロンプト（選択してください）以外が選択されているか？
    const selected = this.element.value !== "";
    const alertTooltip = this.tooltipVisibilityOutlet;

    // selected の場合はアラートのツールチップを表示する。
    if (selected) {
      alertTooltip.show();
    } else {
      alertTooltip.hide();
    }
  }
}
